import React, { FC } from "react"
import { Title, CopyButton, ButtonGroup } from "dash-styled"
import { Breadcrumbs } from "../../../Common/Breadcrumbs/Breadcrumbs"
import { APIAppInstanceModel } from "../../../../../../Models/API/AppInstanceModel"
import { APIJobModel } from "../../../../../../Models/API/JobModel"
import { UITaskModel } from "../../../../../../Models/API/TaskModel"
import { TabButton } from "../../../../../Common/Button/TabButton"

interface DetailViewHeaderProps {
    job: APIJobModel
    instance: APIAppInstanceModel
    taskList?: UITaskModel[]
    selectedTaskID?: string
    onSelectTask: (taskID: string | undefined) => void
}

export const JobDetailViewHeader: FC<DetailViewHeaderProps> = ({
    job,
    instance,
    taskList,
    selectedTaskID,
    onSelectTask
}) => {
    return (
        <div
            data-testid="job-detail-view-header"
            className="flex justify-between items-center"
        >
            <div>
                <Breadcrumbs
                    elements={["Projects", instance.name, "Work Queue"]}
                />
                <div className="flex-shrink-0 flex items-center justify-between pb-2">
                    <Title
                        component="h1"
                        variant="heading1"
                        weight="semibold"
                        className="flex-shrink flex-grow-0"
                        noMargin={true}
                        testId="job-id"
                    >
                        Data point {job.id}
                        <CopyButton
                            className="ml-2"
                            variant="simple"
                            value={window.location.href}
                        />
                    </Title>
                </div>
            </div>
            {taskList && taskList.length > 0 && (
                <ButtonGroup equalWidth={false} className="h-12">
                    <TabButton
                        active={!selectedTaskID}
                        onClick={() => onSelectTask(undefined)}
                    >
                        Overall Data
                    </TabButton>
                    {taskList.map(task => (
                        <TabButton
                            key={task.id}
                            active={task.id.toString() === selectedTaskID}
                            className="min-w-24"
                            onClick={() => onSelectTask(task.id.toString())}
                        >
                            Task {task.taskNumber}
                        </TabButton>
                    ))}
                </ButtonGroup>
            )}
        </div>
    )
}
